import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ConfigProvider, LanguageProvider } from '.';

import { store } from '../redux';

export const RootProvider: React.FC = ({ children }) => (
    <ReduxProvider store={store}>
        <LanguageProvider>
            <ConfigProvider>{children}</ConfigProvider>
        </LanguageProvider>
    </ReduxProvider>
);
